import { FunctionComponent, useState } from "react";
import { Box, TextField } from "@mui/material";

import _debounce from "lodash/debounce";
import { PhoneNumber } from "../../../types/bookingTypes";

export type Props = {
  initValue: PhoneNumber;
  onChange: (value: PhoneNumber) => void;
};

const debouncedOnChange = _debounce(
  (onChange: (value: PhoneNumber) => void, value: PhoneNumber) => {
    onChange(value);
  },
  500
);

const PhoneNumberInputField: FunctionComponent<Props> = ({
  initValue,
  onChange,
}) => {
  const [nationalNumber, setNationalNumber] = useState(
    initValue.nationalNumber ?? ""
  );
  const [countryCode, setCountryCode] = useState(initValue.countryCode ?? "");

  const handleCountryCodeChange = (value: string) => {
    const numericOnly = value.replace(/[^\d+]/g, "");
    setCountryCode(numericOnly);
    debouncedOnChange(onChange, { countryCode: numericOnly, nationalNumber });
  };

  const handleNationalChange = (value: string) => {
    const next = value.replace(/[^\d+]/g, "");
    setNationalNumber(next);
    debouncedOnChange(onChange, { countryCode, nationalNumber: next });
  };

  return (
    <Box style={{ display: "flex" }}>
      <TextField
        name="countryCode"
        label="Landskode"
        value={countryCode}
        onChange={(e) => handleCountryCodeChange(e.target.value)}
        autoComplete="tel-country-code"
        inputMode="numeric"
        aria-label="Landskode"
        style={{ marginRight: 10, maxWidth: 100 }}
        variant="outlined"
      />
      <TextField
        name="nationalNumber"
        data-cy="customer-phone-field"
        label="Telefonnummer"
        value={nationalNumber}
        inputMode="tel"
        type="tel"
        fullWidth
        onChange={(e) => handleNationalChange(e.target.value)}
        autoComplete="tel-national"
        aria-label="Telefonnummer"
        variant="outlined"
      />
    </Box>
  );
};

export default PhoneNumberInputField;
